import { useCallback } from 'react';

import { FormikSingleSelect } from '~/components/Formik/FormikSingleSelect';
import { IMAGE_FORMAT_SINGLE_SELECT } from '~/constants/testIDs';
import { SUPPORTED_EXPORT_FORMATS } from '~/utils/Imgix';

const extensionOptions = SUPPORTED_EXPORT_FORMATS.map((format) => ({
  label: format.toUpperCase(),
  value: format,
}));

export type ExportImageExtSelectProps = {
  setIsEditing: (isEditing: boolean) => void;
};

export const ExportImageExtSelect = ({ setIsEditing }: ExportImageExtSelectProps) => {
  const handleOptionsClose = useCallback(() => setIsEditing(false), [setIsEditing]);
  const handleOptionsOpen = useCallback(() => setIsEditing(true), [setIsEditing]);

  return (
    <FormikSingleSelect
      isSearchable={false}
      size="medium"
      data-testid={IMAGE_FORMAT_SINGLE_SELECT}
      label="Format"
      labelClassName="mb-2 ads:text-secondary text-gray-11"
      name="ext"
      options={extensionOptions}
      onOptionsClose={handleOptionsClose}
      onOptionsOpen={handleOptionsOpen}
      className="w-full"
    />
  );
};
